import { Typography } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from 'dayjs';
import 'dayjs/locale/pt';
import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';

type PeriodSelectProps = {
  selectedPeriodDate: dayjs.Dayjs | null;
  setSelectedPeriodDate: Dispatch<SetStateAction<dayjs.Dayjs | null>>;
};

function PeriodSelect(props: PeriodSelectProps) {
  const { selectedPeriodDate, setSelectedPeriodDate } = props;
  const { i18n, t } = useTranslation('pmo');

  const handleDateChange = (newValue: any) => {
    setSelectedPeriodDate(newValue);
  };

  return (
    <div>
      <div style={{ marginBottom: '.5rem' }}>
        <Typography
          sx={{
            fontWeight: 'bold',
            fontSize: '16px',
            color: '#4b4b4b',
            marginBottom: '4px',
          }}
        >
          <span style={{ color: 'orange' }}> * </span>
          {t('enter.the.period')}
        </Typography>
      </div>
      <div>
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={i18n.language}>
          <DatePicker
            views={['month', 'year']}
            value={selectedPeriodDate}
            onChange={handleDateChange}
            sx={{
              '& .MuiOutlinedInput-notchedOutline': {
                borderRadius: '10px',
              },
              '& .MuiInputBase-root': {
                borderRadius: '10px',
              },
              '& .MuiInputBase-input': {
                paddingY: '8px',
              },
              '& .MuiSvgIcon-root': {
                color: 'orange',
              },
            }}
          />
        </LocalizationProvider>
      </div>
    </div>
  );
}

export default PeriodSelect;
